import errorMessages from '@common/constants/errorMessages';
import { isAllDigits, isEmpty, notEmpty } from '@common/paymentsUtils/inputValidator';

const BIRTHDAY_MIN = 1;
const BIRTHDAY_MAX = 31;

function isRequiredFieldEmpty(value, errorMessage) {
  if (isEmpty(value)) {
    return errorMessage;
  }
  return errorMessages.CLEAR_ERROR;
}

function isDayOfBirthValid(dayOfBirth) {
  if (isEmpty(dayOfBirth)) {
    return errorMessages.DAY_OF_BIRTH_EMPTY;
  } else if (!isAllDigits(dayOfBirth)) {
    return errorMessages.DAY_OF_BIRTH_INVALID;
  } else if (dayOfBirth < BIRTHDAY_MIN) {
    return errorMessages.DAY_OF_BIRTH_INVALID;
  } else if (dayOfBirth > BIRTHDAY_MAX) {
    return errorMessages.DAY_OF_BIRTH_INVALID;
  }
  return errorMessages.CLEAR_ERROR;
}

function isYearOfBirthValid(yearOfBirth, minYear, maxYear) {
  if (isEmpty(yearOfBirth)) {
    return errorMessages.YEAR_OF_BIRTH_EMPTY;
  } else if (!isAllDigits(yearOfBirth)) {
    return errorMessages.YEAR_OF_BIRTH_INVALID;
  } else if (yearOfBirth < minYear) {
    return errorMessages.YEAR_OF_BIRTH_INVALID;
  } else if (yearOfBirth > maxYear) {
    return errorMessages.BIRTH_DATE_INVALID;
  }
  return errorMessages.CLEAR_ERROR;
}

// To validate if user is 18+
function isDateOfBirthValid(monthOfBirth, dayOfBirth, yearOfBirth, maxBirthDate) {
  const maxMonth = maxBirthDate.getUTCMonth() + 1;
  const maxDay = maxBirthDate.getUTCDate();
  const maxYear = maxBirthDate.getUTCFullYear();

  if (notEmpty(yearOfBirth) && notEmpty(dayOfBirth) && notEmpty(monthOfBirth)) {
    if (Number(yearOfBirth) === maxYear) {
      if (monthOfBirth > maxMonth) {
        return errorMessages.BIRTH_DATE_INVALID;
      } else if (Number(monthOfBirth) === maxMonth) {
        if (dayOfBirth > maxDay) {
          return errorMessages.BIRTH_DATE_INVALID;
        }
      }
    }
  }
  return errorMessages.CLEAR_ERROR;
}

export function validateAllInputs(ctx) {
  const { dob, updatedFirstName, updatedLastName } = ctx.state;
  const { monthOfBirth, dayOfBirth, yearOfBirth } = dob;

  const today = new Date();
  const maxBirthDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
  const minBirthDate = new Date('1900-01-01');

  const errors: Record<string, any>[] = [];

  const monthOfBirthError = isRequiredFieldEmpty(monthOfBirth.value, errorMessages.MONTH_OF_BIRTH_EMPTY);
  const dayOfBirthError = isDayOfBirthValid(dayOfBirth.value);
  const yearOfBirthError = isYearOfBirthValid(
    yearOfBirth.value,
    minBirthDate.getUTCFullYear(),
    maxBirthDate.getUTCFullYear(),
  );
  const dateOfBirthError = isDateOfBirthValid(monthOfBirth.value, dayOfBirth.value, yearOfBirth.value, maxBirthDate);
  const yearOfBirthCommonError = yearOfBirthError || dateOfBirthError || '';

  const firstNameError = isRequiredFieldEmpty(updatedFirstName.value, errorMessages.LEGAL_FIRST_NAME_EMPTY);
  const lastNameError = isRequiredFieldEmpty(updatedLastName.value, errorMessages.LAST_NAME_EMPTY);

  if (firstNameError) {
    errors.push({ firstName: firstNameError });
  }

  if (lastNameError) {
    errors.push({ lastName: lastNameError });
  }

  if (monthOfBirthError) {
    errors.push({ monthOfBirth: monthOfBirthError });
  }

  if (dayOfBirthError) {
    errors.push({ dayOfBirth: dayOfBirthError });
  }

  if (yearOfBirthCommonError) {
    errors.push({ yearOfBirth: yearOfBirthCommonError });
  }

  ctx.setDOB({
    ...ctx.state,
    monthOfBirth: { ...monthOfBirth, error: monthOfBirthError },
    dayOfBirth: { ...dayOfBirth, error: dayOfBirthError },
    yearOfBirth: { ...yearOfBirth, error: yearOfBirthCommonError },
  });

  if (errors.length > 0) {
    return false;
  }
  return true;
}
